module.exports = __webpack_public_path__ + "static/media/right.7ce99f94.svg";